import { h, Component } from 'preact'
import cn from 'classnames'
import s from './Search.css'

interface iProps {
  className?: string
}

class Search extends Component<iProps> {
  render () {
    const { className } = this.props

    return (
      <div className={cn(s.Search, className)}>
        <input
          type="text"
          placeholder="Search"
          className={s.Search__field}
        />
      </div>
    )
  }
}

export default Search
